import { Link, useLocation } from 'react-router-dom';
import SeoHead from '../components/SeoHead';

export default function InformationPage() {
  const location = useLocation();
  const isCe = location.pathname.includes('ce-godkendelser');
  const isPartners = location.pathname.includes('samarbejdspartnere');

  const certificates = [
    {
      title: "Glasfibercontainer / 400 liter CE-godkendelse",
      url: "https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/ce-4-hjulet-400-liter.pdf",
      category: "Glasfiber Containere",
    },
    {
      title: "Glasfibercontainer / 600 liter CE-godkendelse",
      url: "https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/ce-4-hjulet-600-liter.pdf",
      category: "Glasfiber Containere",
    },
    {
      title: "Glasfibercontainer / 800 liter CE-godkendelse",
      url: "https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/ce-4-hjulet-800-liter.pdf",
      category: "Glasfiber Containere",
    },
    {
      title: "Glasfibercontainer / 1100 liter CE-godkendelse",
      url: "https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/ce-4-hjulet-1100-liter.pdf",
      category: "Glasfiber Containere",
    },
    {
      title: "Fancy – Fancy hjul CE-godkendelse",
      url: "https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/ce-fancy.pdf",
      category: "Igloer",
    },
    {
      title: "Iglo joca CE-godkendelse",
      url: "https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/ce-iglo-joca.pdf",
      category: "Igloer",
    },
  ];

  const partners = [
    {
      name: "Joca A/S",
      role: "Genbrugsigloer & Affaldssystemer",
      desc: "Tæt samarbejdspartner omkring udvikling og produktion af de velkendte Model joca genbrugsigloer, overjordiske Fancy containere og batteribokse.",
      url: "https://joca.dk/",
    },
    {
      name: "ScanComposit A/S",
      role: "Kompositløsninger",
      desc: "Samarbejdspartner inden for avancerede konstruktioner i fiberarmeret komposit til industri og tekniske installationer.",
      url: "https://www.scancomposit.com/",
    },
    {
      name: "Rockwool",
      role: "Commercial Barrier Terrorsikring",
      desc: "Samarbejde om design, produktion og formbygning til tunge fiberkomposit-barrierer til sikring af offentlige forsamlinger og festivaler.",
    },
    {
      name: "Kommuner & Forsyningsselskaber",
      role: "Spildevand, Affald & Anlæg",
      desc: "Samarbejde med bl.a. Silkeborg Forsyning (Søholt Renseanlæg), Ringkøbing-Skjern Kommune (Hvide Sande affaldsstation) og Færch Plast.",
    },
  ];

  return (
    <>
      <SeoHead
        title={isCe ? 'CE Godkendelser - RB Glasfiber A/S' : isPartners ? 'Samarbejdspartnere - RB Glasfiber A/S' : 'Information - RB Glasfiber A/S'}
        description="Download officielle CE-godkendelser og certifikater på glasfibercontainere og igloer, og læs om vores stærke samarbejdspartnere."
        canonical={`https://www.rb-glasfiber.dk${location.pathname}`}
      />

      {/* Hero Header */}
      <section className="relative pt-32 pb-16 lg:pt-40 lg:pb-24 bg-slate-950 text-white overflow-hidden border-b border-slate-800">
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded bg-[#1e9457]/20 border border-[#1e9457]/40 text-[#22c55e] text-xs font-bold uppercase tracking-widest mb-4">
              <i className="fa-solid fa-circle-info"></i>
              <span>Dokumentation & Netværk</span>
            </div>
            <h1 className="text-3xl sm:text-5xl font-extrabold uppercase tracking-tight text-white mb-6">
              {isCe ? 'CE Godkendelser' : isPartners ? 'Samarbejdspartnere' : 'Information'}
            </h1>
            <p className="text-base sm:text-lg text-slate-300 leading-relaxed max-w-2xl">
              Få overblik over vores officielle CE-godkendelser, certifikater på containere og igloer samt vores faglige samarbejdspartnere.
            </p>

            {/* Quick Filter Tabs */}
            <div className="mt-8 flex flex-wrap items-center gap-3">
              <Link
                to="/information"
                className={`px-4 py-2 rounded text-xs font-bold uppercase tracking-wider transition-colors ${
                  !isCe && !isPartners
                    ? 'bg-[#1e9457] text-white'
                    : 'bg-slate-800 text-slate-300 hover:text-white hover:bg-slate-700'
                }`}
              >
                Samlet oversigt
              </Link>
              <Link
                to="/information/ce-godkendelser"
                className={`px-4 py-2 rounded text-xs font-bold uppercase tracking-wider transition-colors ${
                  isCe
                    ? 'bg-[#1e9457] text-white'
                    : 'bg-slate-800 text-slate-300 hover:text-white hover:bg-slate-700'
                }`}
              >
                CE Godkendelser
              </Link>
              <Link
                to="/information/samarbejdspartnere"
                className={`px-4 py-2 rounded text-xs font-bold uppercase tracking-wider transition-colors ${
                  isPartners
                    ? 'bg-[#1e9457] text-white'
                    : 'bg-slate-800 text-slate-300 hover:text-white hover:bg-slate-700'
                }`}
              >
                Samarbejdspartnere
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-16">
          {/* CE Approvals Section */}
          {(!isPartners || isCe) && (
            <div className="space-y-8">
              <div>
                <div className="inline-flex items-center gap-2 text-xs font-bold text-[#1e9457] uppercase tracking-wider">
                  <span className="w-2 h-2 rounded-full bg-[#1e9457]"></span>
                  Certificering & Kvalitet
                </div>
                <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 uppercase mt-1">
                  CE Godkendelser & Certifikater
                </h2>
                <p className="text-slate-600 text-sm mt-2 max-w-2xl">
                  En lang række af vores produkter er CE godkendte. Herunder kan du hente certifikater på vores 4-hjulede glasfibercontainere og igloer.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {certificates.map((cert, idx) => (
                  <a
                    key={idx}
                    href={cert.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-5 rounded-lg border border-slate-200 bg-slate-50 hover:bg-white hover:border-[#1e9457] hover:shadow-md transition-all group flex flex-col justify-between"
                  >
                    <div>
                      <div className="text-[10px] font-bold uppercase tracking-wider text-[#1e9457] mb-2">
                        {cert.category}
                      </div>
                      <h3 className="font-bold text-slate-900 text-base group-hover:text-[#1e9457] transition-colors">
                        {cert.title}
                      </h3>
                    </div>

                    <div className="pt-4 flex items-center justify-between text-xs font-semibold text-slate-500 group-hover:text-slate-800">
                      <span className="inline-flex items-center gap-1.5 text-rose-700">
                        <i className="fa-solid fa-file-pdf"></i>
                        PDF certifikat
                      </span>
                      <i className="fa-solid fa-download text-[#1e9457] group-hover:translate-y-0.5 transition-transform"></i>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          )}

          {/* Partners Section */}
          {(!isCe || isPartners) && (
            <div className="space-y-8 pt-8 border-t border-slate-200">
              <div>
                <div className="inline-flex items-center gap-2 text-xs font-bold text-[#1e9457] uppercase tracking-wider">
                  <span className="w-2 h-2 rounded-full bg-[#1e9457]"></span>
                  Netværk & Kompetencer
                </div>
                <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 uppercase mt-1">
                  Samarbejdspartnere
                </h2>
                <p className="text-slate-600 text-sm mt-2 max-w-2xl">
                  RB Glasfiber samarbejder med stærke virksomheder og offentlige myndigheder for at levere de stærkeste løsninger i komposit.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {partners.map((partner, idx) => (
                  <div
                    key={idx}
                    className="p-6 rounded-xl border border-slate-200 bg-white shadow-xs space-y-3 flex flex-col justify-between"
                  >
                    <div className="space-y-3">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded bg-[#1e9457]/10 text-[#1e9457] flex items-center justify-center font-bold text-lg">
                          <i className="fa-solid fa-handshake"></i>
                        </div>
                        <div>
                          <h3 className="text-lg font-bold text-slate-900">{partner.name}</h3>
                          <div className="text-xs text-[#1e9457] font-semibold uppercase tracking-wider">
                            {partner.role}
                          </div>
                        </div>
                      </div>
                      <p className="text-sm text-slate-600 leading-relaxed">{partner.desc}</p>
                    </div>

                    {partner.url && (
                      <div className="pt-2 border-t border-slate-100">
                        <a
                          href={partner.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex items-center gap-2 text-xs font-bold text-[#1e9457] hover:text-[#15703f] uppercase tracking-wider transition-colors"
                        >
                          <span>Besøg {partner.name}</span>
                          <i className="fa-solid fa-arrow-up-right-from-square text-[10px]"></i>
                        </a>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
